export const userProviderLoaderTestId = 'UserProvider-Loader';
export const userProviderLoginTestId = 'UserProvider-Login';
export const authProviderHelpTestId = 'AuthProviderHelp';
export const authProviderErrorTestId = 'AuthProviderError';
